import { Controller } from '@hotwired/stimulus'

declare const $: {
  (selector: HTMLElement): {
    on: (event: string, handler: () => void) => void
  }
}

export default class extends Controller {
  static targets = [
    'quickbooksButton',
    'regularButton',
    'syncBannerQuickbooks',
    'syncBannerRegular',
  ]

  declare readonly quickbooksButtonTarget: HTMLElement
  declare readonly regularButtonTarget: HTMLElement
  declare readonly hasQuickbooksButtonTarget: boolean
  declare readonly hasRegularButtonTarget: boolean
  declare readonly syncBannerQuickbooksTarget: HTMLElement
  declare readonly syncBannerRegularTarget: HTMLElement
  declare readonly hasSyncBannerQuickbooksTarget: boolean
  declare readonly hasSyncBannerRegularTarget: boolean

  connect(): void {
    const syncEntitySelect = this.element.querySelector(
      'select[name="ledger_import_configuration[sync_entity_id]"]'
    ) as HTMLSelectElement

    if (syncEntitySelect) {
      this.handleSyncEntityChange(syncEntitySelect)

      $(syncEntitySelect).on('change', () => {
        this.handleSyncEntityChange(syncEntitySelect)
      })
    }
  }

  private handleSyncEntityChange(syncEntitySelect: HTMLSelectElement): void {
    const selectedOption =
      syncEntitySelect.options[syncEntitySelect.selectedIndex]
    const selectedText = selectedOption?.text || ''

    const isQuickBooks = selectedText.toLowerCase().includes('quickbooks')

    this.toggleSyncBanner(isQuickBooks)
    this.toggleSubmitButton(isQuickBooks)
  }

  private toggleSyncBanner(isQuickBooks: boolean): void {
    if (
      !this.hasSyncBannerQuickbooksTarget ||
      !this.hasSyncBannerRegularTarget
    ) {
      return
    }

    this.syncBannerQuickbooksTarget.classList.toggle('sf-hidden', !isQuickBooks)
    this.syncBannerRegularTarget.classList.toggle('sf-hidden', isQuickBooks)
  }

  private toggleSubmitButton(isQuickBooks: boolean): void {
    if (!this.hasQuickbooksButtonTarget || !this.hasRegularButtonTarget) {
      return
    }

    this.quickbooksButtonTarget.classList.toggle('sf-hidden', !isQuickBooks)
    this.regularButtonTarget.classList.toggle('sf-hidden', isQuickBooks)
  }
}
